
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

@Component({
    name: 'LeftMenu',
})
export default class LeftMenu extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get currentLanguage(): string {
        return this.mainStore.state.currentLanguage;
    }
    private get isShowLeftMenu(): boolean {
        return this.mainStore.state.isShowLeftMenu;
    }

    private changeLanguageToSpanish(): void {
        this.mainStore.actions.changeLanguageToSpanish();
    }
    private changeLanguageToEnglish(): void {
        this.mainStore.actions.changeLanguageToEnglish();
    }

    private closeLeftMenu(): void {
        this.mainStore.actions.hideLeftMenu();
    }
}
